import apiRequest from '@/http/api-request';
import authService from '@/auth/authService';

const moment = require('moment');

export default {
  nextPurchaseTicketStep(
    { commit, state },
    { purchaseTicketDetails = {}, saveCurrent = true },
  ) {
    const currentPurchaseTicket = state.purchaseTicket;

    const nextPurchaseTicket = {
      ...currentPurchaseTicket,
      ...purchaseTicketDetails,
      ...(saveCurrent ? { previousState: { ...currentPurchaseTicket } } : {}),
    };

    commit('SET_PURCHASE_TICKET', nextPurchaseTicket);
  },

  previousPurchaseTicketStep({ commit, state }) {
    const currentPurchaseTicket = state.purchaseTicket;

    // Its on the first step
    if (!currentPurchaseTicket.previousState) {
      return;
    }

    commit('SET_PURCHASE_TICKET', currentPurchaseTicket.previousState);
  },

  resetPurchaseTicketStep({ commit }) {
    commit('RESET_PURCHASE_TICKET');
  },

  fetchAllDonations({ commit, state }, { charityId, force = false }) {
    if (state.donationsState === 'loading') {
      return new Promise((resolve) => resolve(state.donations));
    }

    if (
      state.donationsState === 'ready' &&
      force !== true &&
      parseInt(new Date().getTime() / 1000) - state.lastUpdate < 60 * 15 //15 min cache
    ) {
      return new Promise((resolve) => resolve(state.donations));
    }

    commit('LOADING_PURCHASE_TICKET');

    return new Promise((resolve, reject) => {
      return apiRequest
        .doGetRequest(
          '/data/donations',
          {
            charity_id: charityId,
            start_date: '01/01/2016',
            end_date: moment().format('MM/DD/YYYY'),
          },
          { 'X-Harness-JWT': authService.getToken() },
          {
            skipCache: true,
            resCallback: (donations) => {
              // Pre-parse the created_at timestamp so we don't need to re-parse it multiple times later.
              for (let donation of donations) {
                donation.createdAtParsed = moment(
                  donation.created_at,
                  'YYYY/MM/DD HH:mm:ss',
                ).unix();
              }

              return donations;
            },
          },
        )
        .then((donations) => {
          commit('SET_DONATIONS', donations);
          resolve(donations);
        })
        .catch((error) => reject(error));
    });
  },

  setGuestInfoWizardOn({ commit, state }) {
    commit('SET_PURCHASE_TICKET', {
      ...state.purchaseTicket,
      wizardStepsCount: 4,
    });
  },
};
